import React from 'react';
import ReactDOM from 'react-dom';
import jsPDF from "jspdf";
import html2canvas from 'html2canvas';
import { truncateTextWithEllipsis } from './StringHelper';
import {
    CANVAS_CONVERSION_SCALE,
    CANVAS_QUALITY_IMAGE,
    COMMENTS_CSS_CLASS,
    MAX_LINES_FOR_APPLY_ELLIPSIS_OBJECTIVE,
    MAX_LINES_FOR_APPLY_ELLIPSIS_FOR_COMMENTS,
    OBJECTIVES_CSS_CLASS,
    OBJECTIVES_TCDI_CSS_CLASS,
    MAX_LINES_FOR_APPLY_ELLIPSIS_OBJECTIVE_TCDI
} from '../Constants/ProjectReportConstants';


export const generatePageInPDF = async (data: any, pdf: jsPDF, container: any, Component: React.FC<{ data: any }>, delay: number = 300) => {
    const pdfWidth = pdf.internal.pageSize.getWidth();

    ReactDOM.render(<Component data={data} />, container);
    await new Promise((resolve) => setTimeout(resolve, delay));

    applyEllipsisToClass(container, OBJECTIVES_CSS_CLASS);
    applyEllipsisToClass(container, OBJECTIVES_TCDI_CSS_CLASS, MAX_LINES_FOR_APPLY_ELLIPSIS_OBJECTIVE_TCDI);
    applyEllipsisToClass(container, COMMENTS_CSS_CLASS, MAX_LINES_FOR_APPLY_ELLIPSIS_FOR_COMMENTS);

    const canvas = await html2canvas(container, {
        scale: CANVAS_CONVERSION_SCALE,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        onclone: (clonedDoc) => {
            const styles = clonedDoc.createElement('style');
            styles.innerHTML = `
              * {
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            `;
            clonedDoc.head.appendChild(styles);
        }
    });
    const imgData = canvas.toDataURL('image/jpeg', CANVAS_QUALITY_IMAGE);

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.addPage();
};

function applyEllipsisToClass(container: any, className: string, maxLines = MAX_LINES_FOR_APPLY_ELLIPSIS_OBJECTIVE) {
    const objectiveElement = container.querySelector(className);

    if (objectiveElement) {
        truncateTextWithEllipsis(objectiveElement, maxLines);
    }
}
